module.exports = __webpack_public_path__ + "img/szbanner.1de55b3c.jpg";